export default __webpack_public_path__ + "static/media/729.cc9ddc9f.png";